import toInteger from 'lodash/toInteger';

import LabelPrintTemplate from 'label/LabelPrintTemplate';
import { getItemPrintedTimestamp } from 'label/utils/timeStampHelpers';
import { LabelData, LabelEditorItem, LabelItemAttributes } from 'label/utils/types';

import { getVendor } from './vendorIdHelpers';

export async function transformToLabelEditorItems(
  labelData: LabelData[],
  labelQuantity?: number,
  freeFormFieldValue?: string | number | undefined
): Promise<LabelEditorItem[]> {
  const todaysDate = await getItemPrintedTimestamp();
  return labelData.map((data) => {
    let matrixAttributes;

    if (data.Item.ItemAttributes) {
      const itemAttributesObj = data.Item.ItemAttributes;

      matrixAttributes = ['attribute1', 'attribute2', 'attribute3']
        .map((attribute) => itemAttributesObj[attribute as keyof LabelItemAttributes])
        .filter(Boolean)
        .join(' ');
    }

    const shopName = window.merchantos.session.getShop()?.name || '';

    const item: LabelEditorItem = {
      barcode: {
        ean: data.Item.ean,
        upc: data.Item.upc,
        systemSku: data.Item.systemSku,
      },
      itemPrice: `${data.m.price}`,
      brand: data.Item.Manufacturer?.name || '',
      itemDescription: data.Item.description,
      matrixAttributes: matrixAttributes || '',
      msrp: LabelPrintTemplate.printMsrp(data)
        ? `${LabelPrintTemplate.getMsrp(data)?.amount || ''}`
        : '',
      shopName,
      todaysDate,
      vendorId: getVendor(data) || '',
      manufacturerSku: data.Item.manufacturerSku,
      customSku: data.Item.customSku,
      quantity: labelQuantity || toInteger(data.copies) || 1,
      category: {
        name: data.Item.Category?.name || '',
        fullPathName: data.Item.Category?.fullPathName || '',
      },
      systemID: data.Item.systemSku,
      freeForm: freeFormFieldValue,
    };

    return item;
  });
}
